module.exports = __webpack_public_path__ + "img/bg-medium.fc043ed9.png";